export default {
  computed: {
    $translate() {
      if (window.is_foreign) return true;
      if (this.isBrazil === false) return true;
      return false;
    }
  },
  methods: {
    $t(text) {
      return this.$translate ? translations[text] || text : text;
    },
    $terms() {
      return this.$translate ?
        'By continuing, you agree to the <a target="_blank" href="https://pay.velora.com.br/termos-de-uso/">terms of use</a> and <a target="_blank" href="https://pay.velora.com.br/politica-de-privacidade/">privacy policies</a>' :
        'Ao continuar, você concorda com os <a target="_blank" href="https://pay.velora.com.br/termos-de-uso/">termos de uso</a> e <a target="_blank" href="https://pay.velora.com.br/politica-de-privacidade/">políticas de privacidade</a>';
    },
    $taxInstallment() {
      return this.$translate ?
      `*Illustrative amount. The final purchase amount will be charged by your card issuer. Therefore, there may be variations when billed.` :
      `* parcelamento com acréscimo`;
      // `*installment payment at a rate of ${product.tax_install}% p.m.` :
      // `*parcelamento com tarifa de ${product.tax_install}% a.m`;
    }
  }
}

var translations = {
  "DADOS PESSOAIS": "CUSTOMER INFORMATION",
  "DADOS DE PAGAMENTO": "PAYMENT",
  "Pagar agora": "Pay now",
  "Número do cartão": "Card number",
  "Titular do cartão": "Card owner name",
  "Data de validade": "Expiration date",
  "AA": "YY",
  "Código de segurança": "Security code",
  "Opções de parcelamento": "Installment options",
  "COMPRA 100% SEGURA": "100% SAFE PURCHASE",
  "RESUMO DA COMPRA": "PURCHASE SUMMARY",
  "Produto": "Product",
  "Preço": "Price",
  "Desconto": "Discount",
  "Formas de pagamento": "Payment methods",
  "Seu nome completo": "Your full name",
  "Seu CPF/CNPJ": "Your document",
  "Seu e-mail": "Your e-mail",
  "Confirme seu e-mail": "Confirm your e-mail",
  "Número de telefone": "Your phone number",
  "Seu Instagram": "Your Instagram",
  "Próximo passo": "Next step",
  "Total a pagar": "Total amount",
  "Curso online": "Online course",
  "Assinatura": "Signature",
  "por dia": "per day",
  "por semana": "per week",
  "por mês": "per month",
  "por bimestre": "bimonthly",
  "por trimestre": "per semester",
  "por ano": "per year",
}